import { createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../config";
import axiosClient from "../../common/api/request";

export const NOTIFICATIONS_PER_PAGE = 10;

// Every notification call rejects with the server's body plus the HTTP
// status, so the slice can tell a vanished row (404: the order was deleted
// and its lines went with it) from a real failure.
const toNotificationError = (error) => {
  if (
    error?.response &&
    error?.response?.data &&
    typeof error?.response?.data === "object"
  ) {
    return { ...error.response.data, status: error.response.status };
  }
  return { detail: error?.message, status: error?.response?.status };
};

// One page of the customer's feed, newest first. Params: { page, per_page,
// is_read, type }. `meta` carries the unread/read counters for the WHOLE
// feed whatever the filter, so the badge never counts the page.
export const getNotifications = createAsyncThunk(
  "notifications/get",
  async (params = {}, { rejectWithValue }) => {
    try {
      const data = await axiosClient.get(
        `${config.API_URL_V2}/notifications/`,
        { params }
      );
      return { ...(data || {}), page: params?.page || 1 };
    } catch (error) {
      return rejectWithValue(toNotificationError(error));
    }
  }
);

// Flips one line; `{ is_read: false }` is allowed and marks it unread again.
// Answers the updated row. 404 when the id is not the customer's (or the
// order behind it is gone).
export const markNotificationRead = createAsyncThunk(
  "notifications/markRead",
  async ({ id, is_read }, { rejectWithValue }) => {
    try {
      const data = await axiosClient.patch(
        `${config.API_URL_V2}/notifications/${id}/`,
        { is_read }
      );
      return data;
    } catch (error) {
      return rejectWithValue(toNotificationError(error));
    }
  }
);

// Marks every line read. Answers { marked_as_read }.
export const markAllNotificationsRead = createAsyncThunk(
  "notifications/markAllRead",
  async (_, { rejectWithValue }) => {
    try {
      const data = await axiosClient.post(
        `${config.API_URL_V2}/notifications/mark-all-read/`,
        {}
      );
      return data;
    } catch (error) {
      return rejectWithValue(toNotificationError(error));
    }
  }
);
